export default "__VITE_ASSET__DVQvhTLO__"